import BasicButton from './BasicButton';

export default BasicButton;